module.exports = __webpack_public_path__ + "Roboto-Medium.76cad5ba6b8a38a77fe0.eot";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Medium.eot
// module id = 98
// module chunks = 2